// extracted by mini-css-extract-plugin
export var content = "_ok-1";
export var noScroll = "_ok-3";
export var paper = "_ok-0";
export var scrollable = "_ok-2";